const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const ExpenseService = {
  getAllExpenseWithParams,
  postExpense,
  updateExpense,
};

function getAllExpenseWithParams(params) {
  const { startDate, endDate, siteId } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/expense`, {
      params: {
        startDate,
        endDate,
        siteId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function postExpense(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/expense`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateExpense(id, body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/expense?id${id}`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}
